import { render, staticRenderFns } from "./EMailSettings.vue?vue&type=template&id=b7c4233e&"
import script from "./EMailSettings.vue?vue&type=script&lang=js&"
export * from "./EMailSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports